import { UserType, Feature } from '@ngb-frontend/shared/types'

export const getJourneyType = (userType: UserType): Feature => {
  if (userType === UserType.Agent) return Feature.MnRDCC
  if (userType === UserType.Broker) return Feature.EoLDCC

  return Feature.MnR
}
